import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';

const DoctorLogin = React.lazy(() => import('../../views/DoctorLogin'));

const params = [];
const DoctorLoginRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<></>} footer={<></>}>
        <DoctorLogin />
      </Layout>
    </RouteParameter>
  );
};

DoctorLoginRoute.propTypes = {};

DoctorLoginRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(DoctorLoginRoute);
